import { getFontSizes } from './helper';

export const indigoTheme = {
  colors: {
    base: {
      primary: 'var(--color-primary)',
      secondary: '',
    },
    text: {
      primary: '#000',
      secondary: '',
    },
    button: {
      primary: {
        bg: '#26329F',
        text: '#FFFFFF',
      },
      secondary: {
        bg: '#ffffff',
        text: '#26329F',
      },
      topNav: {
        bg: 'var(--color-primary)',
        text: 'var(--color-btn-primary-text)',
      },
    },
    label: {
      primary: 'var(--color-primary)',
      secondary: '',
    },
    link: {
      primary: 'var(--color-link-primary)',
      secondary: 'var(--color-link-secondary)',
    },
    slider: {
      track: 'var(--color-slider-track)',
    },
    topNav: '#FFFFFF',
    overlays: {
      topNavForm: '#ffffff',
    },
    bodyBG: '#f2f2f2',
    bodyBGListing: '#f2f2f2',
    topnavInput: '#000000',
    agentInputBG: 'rgba(0, 0, 0, 0.1)',
    agentSearchIconBG: '#26329F',
    exploreLinksColor: '#26329F',
  },
  font: {
    size: {
      main: getFontSizes(),
      pageHeader: '40px',
      heading: '32px',
      subHeading: '16px',
      button: getFontSizes('12px', '16px', '18px', '20px'),
    },
    weight: '900',
  },
  images: {
    logo: '',
    mainBg: '',
    favicon: 'https://jsak.mmtcdn.com/holidays/node/images/common/igo_logo.png',
  },
  radius: {
    button: {
      topNav: '6px',
      primary: '6px',
      secondary: '6px',
    },
  },
  topNav: {
    inputContainerBorder: '1px solid rgba(54,54,54, 0.1)',
  },
  detailsPage: {
    mainNav: {
      fontSize: '14px',
      fontWeight: '900',
    },
    itineraryNav: {
      bgColor: '#FAFDFF',
      marginBottom: '0',
      tab: {
        color: '#4a4a4a',
        bgColor: 'transparent',
        active: {
          bgColor: 'var(--color-primary)',
          color: 'var(--color-btn-primary-text)',
        },
      },
    },
    dayplan: {
      bgColor: '#ffffff',
      title: {
        bg: 'var(--color-primary)',
        bg2: 'var(--color-primary)',
        color: 'var(--color-btn-primary-text)',
      },
      flightUpgradeRow: {
        bg: '#EAF5FF',
        margin: '10px 0 0',
        borderRadius: '0',
      },
    },
  },
  thankyouPage: {
    topHeaderColor: '#FFF',
    bg: ' linear-gradient(238.38deg, #7195C8 -141.22%, #26329F 87.22%)',
  },
  reviewPage: {
    bgColor: '#001b94',
    navColor: '#9b9b9b',
  },
};
